export default __webpack_public_path__ + "static/media/restart.c93021e7.svg";